import { produce } from "immer";
import {
  ADD_VISITOR,
  ADD_VISITOR_FAILURE,
  ADD_VISITOR_SUCCESS,
  //
  DELETE_VISITOR,
  DELETE_VISITOR_FAILURE,
  DELETE_VISITOR_SUCCESS,
  //
  EDIT_VISITOR,
  EDIT_VISITOR_FAILURE,
  EDIT_VISITOR_SUCCESS,
  //
  FETCH_VISITORS,
  FETCH_VISITORS_FAILURE,
  FETCH_VISITORS_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  CLOCK_VISITOR,
  CLOCK_VISITOR_SUCCESS,
  CLOCK_VISITOR_FAILURE,
  //
  SEARCH_VISITOR,
  SEARCH_VISITOR_SUCCESS,
  SEARCH_VISITOR_FAILURE,
  //
  SEARCH_RESIDENT,
  SEARCH_RESIDENT_SUCCESS,
  SEARCH_RESIDENT_FAILURE,
  //
  EXPORT_VISITORS,
  EXPORT_VISITORS_SUCCESS,
  EXPORT_VISITORS_FAILURE,
  //
  FETCH_ENTRIES,
  FETCH_ENTRIES_SUCCESS,
  FETCH_ENTRIES_FAILURE,
  //
  FIND_VISITOR,
  FIND_VISITOR_SUCCESS,
  FIND_VISITOR_FAILURE,
} from "./constants";

export const initialState = {
  isFetchingVisitors: false,
  visitors: [],
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  currentVisitor: {},
  // Delete
  isDeleting: false,
  //
  //
  isClockingVisitor: false,
  searchVisitors: [],
  isSearchingVisitors: false,
  // Resident
  isSearchingResidents: false,
  searchResidents: [],
  // Export
  isExporting: false,
  // Entries
  isFetchingEntries: false,
  entries: [],
  // Find
  isFindingVisitors: false,
  foundVisitors: [],
};

const VisitorReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_VISITORS:
        draft.isFetchingVisitors = true;
        draft.visitors = [];
        break;
      case FETCH_VISITORS_SUCCESS:
        draft.isFetchingVisitors = false;
        draft.visitors = action.payload;
        break;
      case FETCH_VISITORS_FAILURE:
        draft.isFetchingVisitors = false;
        draft.visitors = [];
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentVisitor = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentVisitor = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        draft.currentVisitor = {};
        break;
      // Add
      case ADD_VISITOR:
        draft.isSubmitting = true;
        break;
      case ADD_VISITOR_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_VISITOR_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_VISITOR:
        draft.isSubmitting = true;
        break;
      case EDIT_VISITOR_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_VISITOR_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_VISITOR:
        draft.isDeleting = true;
        break;
      case DELETE_VISITOR_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_VISITOR_FAILURE:
        draft.isDeleting = false;
        break;
      // Clock
      case CLOCK_VISITOR:
        draft.isClockingVisitor = true;
        break;
      case CLOCK_VISITOR_SUCCESS:
        draft.isClockingVisitor = false;
        break;
      case CLOCK_VISITOR_FAILURE:
        draft.isClockingVisitor = false;
        break;
      // Search
      case SEARCH_VISITOR:
        draft.isSearchingVisitors = true;
        break;
      case SEARCH_VISITOR_SUCCESS:
        draft.isSearchingVisitors = false;
        draft.searchVisitors = action.payload;
        break;
      case SEARCH_VISITOR_FAILURE:
        draft.isSearchingVisitors = false;
        draft.searchVisitors = [];
        break;
      // Resident
      case SEARCH_RESIDENT:
        draft.isSearchingResidents = true;
        break;
      case SEARCH_RESIDENT_SUCCESS:
        draft.isSearchingResidents = false;
        draft.searchResidents = action.payload;
        break;
      case SEARCH_RESIDENT_FAILURE:
        draft.isSearchingResidents = false;
        draft.searchResidents = [];
        break;
      // Export
      case EXPORT_VISITORS:
        draft.isExporting = true;
        break;
      case EXPORT_VISITORS_SUCCESS:
        draft.isExporting = false;
        break;
      case EXPORT_VISITORS_FAILURE:
        draft.isExporting = false;
        break;
      // Entries
      case FETCH_ENTRIES:
        draft.isFetchingEntries = true;
        break;
      case FETCH_ENTRIES_SUCCESS:
        draft.isFetchingEntries = false;
        draft.entries = action.payload;
        break;
      case FETCH_ENTRIES_FAILURE:
        draft.isFetchingEntries = false;
        draft.entries = [];
        break;
      // Find
      case FIND_VISITOR:
        draft.isFindingVisitors = true;
        break;
      case FIND_VISITOR_SUCCESS:
        draft.isFindingVisitors = false;
        draft.foundVisitors = action.payload;
        break;
      case FIND_VISITOR_FAILURE:
        draft.isFindingVisitors = false;
        draft.foundVisitors = [];
        break;
    }
  });

export default VisitorReducer;
